(function(ws) {
    'use strict';

    ws.views.recentRenewals = ws.views.recentItems.extend({
        GTM_EVENT_ACTION: 'click_recent_renewals',
        GTM_EVENT_LABEL: 'quote_number',

        ADOBE_EVENT_ACTION: 'view renewal quotes'
    });
})(westcon);
